// extracted by mini-css-extract-plugin
export default {"productGallery":"TG-z","inQuickShop":"UG-z"};